// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2-9L-","topBottomGutter":"Layout_topBottomGutter__3jFUB"};